import { render } from "./Khulna.vue?vue&type=template&id=d36db0d6"
import script from "./Khulna.vue?vue&type=script&lang=js"
export * from "./Khulna.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__